import { getAppData } from './dataFetch';
import {
  AppDispatch,
  SetLoadingAction,
  SetNetworkStatusAction,
  SetDataAction,
  SetMenuEnabledAction,
  AppDataState,
} from '../types';

export const loadAppData = () => async (dispatch: AppDispatch): Promise<void> => {
  const data = await getAppData();
  dispatch(setData(data));
  dispatch(setLoading(false));
};

export const setLoading = (isLoading: boolean): SetLoadingAction => ({
  type: 'set-app-loading',
  isLoading,
});

export const setNetworkStatus = (networkStatus: boolean): SetNetworkStatusAction => ({
  type: 'set-network-status',
  networkStatus,
});

export const setData = (data: Partial<AppDataState>): SetDataAction => ({
  type: 'set-app-data',
  data,
});

export const setMenuEnabled = (menuEnabled: boolean): SetMenuEnabledAction => ({
  type: 'set-menu-enabled',
  menuEnabled,
});
